import React from "react";
import { PillSearchField } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var SearchField = function SearchField(_ref) {
  var onChange = _ref.onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Search" : _ref$placeholder,
    _ref$leadingIcon = _ref.leadingIcon,
    leadingIcon = _ref$leadingIcon === void 0 ? "fa-light fa-magnifying-glass" : _ref$leadingIcon,
    _ref$enableClear = _ref.enableClear,
    enableClear = _ref$enableClear === void 0 ? false : _ref$enableClear,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value;
  return /*#__PURE__*/_jsx(PillSearchField, {
    onChange: onChange,
    placeholder: placeholder,
    leadingIcon: leadingIcon,
    enableClear: enableClear,
    value: value
  });
};
export default SearchField;